import {useState} from "react";
import ModalPackCode from "../../UI/Modal/ModalPackCode";
import {useTranslation} from 'react-i18next';

const CodeEntry = (props) => {

	const [showModal, setShowModal] = useState(false);
	const {register, formState, promotionSettings} = props;
	const {t} = useTranslation();

	const handleModal = () => {
		setShowModal(!showModal);
	};

	return (
		<>
			<div className="promo-fields-group promo-fields__border-bottom">
				<div className="promo-fields">
					<div className="promo-field">
						<div className="promo-fields-header">
							<h3 className="heading5 promo-fields-title">{t("Enter the code")}*</h3>
							<button type='button' className='btn btn-primary-text pweu-modal link'
									onClick={handleModal}>{t("Where is my code?")}</button>
							{showModal &&
								<ModalPackCode handleModal={handleModal} promotionSettings={promotionSettings}/>}
							<input type="text" placeholder={t("Enter the code")} name="code" {...register("code", {
								required: true, validate: (value) => {
									return !!value.trim()
								}
							})} />
							{(formState.errors.code?.type === "required" || formState.errors.code?.type === "validate") && (
								<span className="error">{t("Please add your code")}</span>
							)}
							{promotionSettings.promotion_type.enter_code_instructions &&
								<div className="enter-code-instructions">
									{promotionSettings.promotion_type.enter_code_instructions}
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default CodeEntry;
